import { LocaleCode, LocaleMeta, TranslationMessages } from './types';
import en from './locales/en';
import fr from './locales/fr';
import es from './locales/es';
import de from './locales/de';
import de_AT from './locales/de-AT';
import ru from './locales/ru';
import it from './locales/it';
import pl from './locales/pl';
import nl from './locales/nl';
import sv from './locales/sv';
import no from './locales/no';
import sq from './locales/sq';
import pt from './locales/pt';

export const LOCALES: LocaleMeta[] = [
  { code: 'fr', label: 'French', nativeLabel: 'Français' },
  { code: 'en', label: 'English', nativeLabel: 'English' },
  { code: 'es', label: 'Spanish', nativeLabel: 'Español' },
  { code: 'de', label: 'German', nativeLabel: 'Deutsch' },
  { code: 'ru', label: 'Russian', nativeLabel: 'Русский' },
  { code: 'it', label: 'Italian', nativeLabel: 'Italiano' },
  { code: 'pl', label: 'Polish', nativeLabel: 'Polski' },
  { code: 'nl', label: 'Dutch', nativeLabel: 'Nederlands' },
  { code: 'sv', label: 'Swedish', nativeLabel: 'Svenska' },
  { code: 'no', label: 'Norwegian', nativeLabel: 'Norsk' },
  { code: 'de-AT', label: 'Austrian', nativeLabel: 'Österreichisch' },
  { code: 'sq', label: 'Albanian', nativeLabel: 'Shqip' },
  { code: 'pt', label: 'Portuguese', nativeLabel: 'Português' },
];

export const messagesByLocale: Record<LocaleCode, TranslationMessages> = {
  en,
  fr,
  es,
  de,
  ru,
  it,
  pl,
  nl,
  sv,
  no,
  'de-AT': de_AT,
  sq,
  pt,
};

export const DEFAULT_LOCALE: LocaleCode = 'fr';
export const STORAGE_KEY = 'ts_locale';

export function isLocaleCode(value: string): value is LocaleCode {
  return value in messagesByLocale;
}

export function detectLocale(): LocaleCode {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && isLocaleCode(stored)) return stored;
  } catch {
    /* ignore */
  }

  if (typeof navigator !== 'undefined') {
    const candidates = [navigator.language, ...(navigator.languages || [])];
    for (const raw of candidates) {
      const lower = raw.toLowerCase();
      if (lower.startsWith('de-at') || lower === 'at') return 'de-AT';
      const short = lower.split('-')[0];
      if (isLocaleCode(short)) return short;
      if (lower === 'nb' || lower === 'nn') return 'no';
    }
  }

  return DEFAULT_LOCALE;
}

export type { LocaleCode, TranslationMessages, LocaleMeta };
